export default __webpack_public_path__ + "static/media/cfi_logo_proviso_home.cb6ac8ec.svg";